export const COMPLETED = 'completed'
export const EDIT = 'edit'
export const IMPORTANT = 'important'
